import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { ListStore } from '@src/mobile/details/layout/store';

const DramaListModal = props => {
    const { toggle, list, dramaIndex, onChangeDramaIndex } = props;
    const [height, setHeight] = useState(0);
    const [isClosed, setIsClosed] = useState(false);

    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { gagsList } = listStates;

    const listRef = useRef();

    useEffect(() => {
        const rect = document.getElementById('introductionHeader').getBoundingClientRect();

        setHeight(window.innerHeight - rect.bottom - 9);
        const target = listRef.current.children[dramaIndex];

        target.parentNode.scrollTop = target.offsetTop;
    }, []);

    const chooseDrama = (item, index) => {
        setIsClosed(true);
        setTimeout(() => {
            onChangeDramaIndex(index);
            const gags = gagsList[index];

            changeListStates({
                currentVideo: item,
                gags,
            });
            toggle();
        }, 200);
    };

    const close = () => {
        setIsClosed(true);
        setTimeout(toggle, 200); // 动画
    };

    return (
        <div className={`${styles.modal} ${isClosed ? styles.closed : ''}`} style={{ height: `${height}px` }}>
            <div className={styles.toolbar}>
                <span>共{list.length}集</span>
                <span className={styles.close} onClick={close}>
                    <img
                        src="https://x0.ifengimg.com/ucms/2022_17/19D87FD3FCE3FBE74C5EA80702902974261F3F56_size2_w96_h96.png"
                        alt="close"
                    />
                </span>
            </div>
            <div className={styles.list} ref={listRef}>
                {list.map((drama, index) => {
                    const { extText } = drama;

                    return (
                        <div
                            key={index}
                            className={`${styles.item} ${dramaIndex === index ? styles.active : ''}`}
                            onClick={() => chooseDrama(drama, index)}>
                            <div className={styles.num}>{extText ? extText : `第 ${index + 1} 集`}</div>
                            <div className={styles.title}>{drama.title2 ? drama.title2 : drama.title}</div>
                        </div>
                    );
                })}
                <div className={styles.blank} />
            </div>
        </div>
    );
};

DramaListModal.propTypes = {
    toggle: PropTypes.func,
    list: PropTypes.array,
    dramaIndex: PropTypes.number,
    onChangeDramaIndex: PropTypes.func,
};

export default DramaListModal;
